/**
 * Constantes do benchmark do grupo familiar.
 *
 * O benchmark é uma FK para `benchmarks` — o mesmo cadastro de benchmarks do
 * escritório usado pelo motor de consolidação. `id_benchmark` nulo significa
 * "sem benchmark próprio": o backend usa o padrão do escritório, e a UI precisa
 * dizer isso ao consultor em vez de mostrar campo vazio.
 */

/** Origem do benchmark exibido, como o backend devolve na listagem. */
export const BENCHMARK_ORIGEM = {
  GRUPO: 'grupo',
  ESCRITORIO_DEFAULT: 'escritorio_default',
}

/** Rótulo do grupo que não configurou benchmark próprio. */
export const BENCHMARK_LABEL_PADRAO_ESCRITORIO = 'Padrão do escritório'

/**
 * Ponto de entrada do fluxo de grupo familiar.
 *
 * Os modais de grupo/vínculo são montados em dois lugares (a listagem do CRM e
 * a aba de grupo familiar da ficha do cliente) e escutam o mesmo canal do
 * `GlobalBus`. Cada instância declara qual origem atende — assim só uma abre
 * quando as duas estão montadas ao mesmo tempo, e cada origem tem a sua própria
 * regra de campo obrigatório (na listagem o obrigatório é o grupo; na ficha do
 * cliente, o cliente).
 */
export const GRUPO_FAMILIAR_ORIGEM = {
  LISTAGEM: 'listagem',
  CLIENTE: 'cliente',
}

/** Texto exibido quando não há valor para a célula. */
export const TRACO = '—'
